<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="visible"
        data-testid="show-me-overlay"
        class="fixed left-0 top-0 z-[200] flex max-w-none items-center justify-center overflow-hidden px-6 py-10"
        :class="viewportRotationClasses"
        aria-live="polite"
      >
        <!-- Scrim fills the rotated logical viewport (same model as QuotaExceededScreen / WaitingBufferScreen) -->
        <div
          class="pointer-events-none absolute inset-0 z-0 bg-black/65"
          aria-hidden="true"
        />
        <p
          class="show-me-overlay-title relative z-10 max-w-[95vw] break-words text-center font-extrabold leading-[1.05] tracking-wider text-white [filter:drop-shadow(0_0_48px_rgba(6,182,212,0.5))_drop-shadow(0_0_96px_rgba(232,121,249,0.22))] motion-reduce:[filter:drop-shadow(0_0_24px_rgba(6,182,212,0.35))]"
        >
          {{ title }}
        </p>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'
import usePlayer from '@/composables/usePlayer'
import { usePlayerViewportRotationClasses } from '@/composables/usePlayerViewportRotationClasses'

const { state } = usePlayer()
const { showMeOverlay } = toRefs(state)
const { viewportRotationClasses } = usePlayerViewportRotationClasses()
const visible = computed(() => showMeOverlay.value.visible)
const title = computed(() => showMeOverlay.value.title)
</script>

<style scoped>
.show-me-overlay-title {
  font-size: clamp(3.25rem, 16vmin, 18rem);
}
</style>
